import {DialogTypes} from 'common/names';
import {layoutActions} from 'features/layout/redux';
import React from 'react';
import {useDispatch} from 'react-redux';

export const useOpenAlertDialog = () => {
   const dispatch = useDispatch();

   const openDialog = React.useCallback(
      ({content, title}: {content: string; title?: string}) => {
         dispatch(
            layoutActions.openSubDialog({
               id: DialogTypes.AlertDialog.id,
               title,
               content,
            })
         );
      },
      [dispatch]
   );

   return openDialog;
};
